/* ============================================================
   GW · Reels
   Dos cosas: que solo se reproduzca lo que está en pantalla y
   que el botón de sonido deje uno solo con voz.
   ============================================================ */

if (!customElements.get('gw-reels')) {
  class GwReels extends HTMLElement {
    connectedCallback() {
      this.tira = this.querySelector('[data-gwrl-tira]');
      this.videos = Array.from(this.querySelectorAll('video'));

      this.vigilar();
      this.iniciarSonido();
      this.iniciarFlechas();
    }

    disconnectedCallback() {
      this.observador?.disconnect();
    }

    /* Un vídeo fuera de pantalla sigue descargando y pintando
       fotogramas. Con seis en fila eso es el ventilador del móvil. */
    vigilar() {
      if (!this.videos.length) return;

      const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (quieto) return;

      if (!('IntersectionObserver' in window)) {
        this.videos.forEach((v) => v.play().catch(() => {}));
        return;
      }

      this.observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((e) => {
            const video = e.target;
            if (e.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
              // Al salir se vuelve a mudo: si no, reaparece hablando
              if (!video.muted) this.silenciarTodo();
            }
          });
        },
        { threshold: 0.4 }
      );

      this.videos.forEach((v) => this.observador.observe(v));
    }

    silenciarTodo() {
      this.videos.forEach((v) => { v.muted = true; });
      this.querySelectorAll('[data-gwrl-sonido]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
    }

    iniciarSonido() {
      this.querySelectorAll('[data-gwrl-sonido]').forEach((boton) => {
        boton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const card = boton.closest('[data-gwrl-card]');
          const video = card?.querySelector('video');
          if (!video) return;

          const encender = video.muted;
          this.silenciarTodo();

          if (encender) {
            video.muted = false;
            boton.setAttribute('aria-pressed', 'true');
            video.play().catch(() => {});
          }
        });
      });
    }

    iniciarFlechas() {
      const atras = this.querySelector('[data-gwrl-atras]');
      const alante = this.querySelector('[data-gwrl-alante]');
      if (!this.tira || !atras || !alante) return;

      const paso = () => {
        const card = this.tira.querySelector('[data-gwrl-card]');
        if (!card) return this.tira.clientWidth;
        const hueco = parseFloat(getComputedStyle(this.tira).gap) || 0;
        return card.getBoundingClientRect().width + hueco;
      };

      atras.addEventListener('click', () => this.tira.scrollBy({ left: -paso(), behavior: 'smooth' }));
      alante.addEventListener('click', () => this.tira.scrollBy({ left: paso(), behavior: 'smooth' }));

      const pintar = () => {
        const max = this.tira.scrollWidth - this.tira.clientWidth - 2;
        atras.disabled = this.tira.scrollLeft <= 2;
        alante.disabled = this.tira.scrollLeft >= max;
      };

      this.tira.addEventListener('scroll', pintar, { passive: true });
      window.addEventListener('resize', pintar);
      pintar();
    }
  }

  customElements.define('gw-reels', GwReels);
}